<template>
  <AppWithLoading :fetch="fetchIfNull">
    <div class="plan-ended-bar" v-if="quota && !quota.interviews">
      <div class="plan-ended-bar__wrap">
        <div class="plan-ended-bar__icon-wrap">
          <svg
            class="plan-ended-bar__icon"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.5">
              <path d="M1.33325 28H30.6666L15.9999 2.66666L1.33325 28ZM17.3333 24H14.6666V21.3333H17.3333V24ZM17.3333 18.6667H14.6666V13.3333H17.3333V18.6667Z" fill="#FF0000" />
            </g>
          </svg>
        </div>
        <div class="plan-ended-bar__text">
          <span class="d-block d-md-inline"><b>{{ $t("planEnded") }}</b></span>
          {{ $t("planEndedText") }}
        </div>
      </div>
      <a href="/settings/payment/plans" class="plan-ended-bar__link">
        {{ $t('more') }}
      </a>
    </div>
    <FeatureAlertCard v-if="featureAlertVisible" @close="showFeatureAlertCard = false" />
  </AppWithLoading>
</template>

<script>
import {
  computed,
  ref,
} from '@vue/composition-api';
import useAccount from '@/compositions/accounting/useAccount';
import useSubscription from '@/compositions/accounting/useSubscription';
import AppWithLoading from '@/components/AppWithLoading';
import FeatureAlertCard from '@/components/Company/FeatureAlertCard.vue';
import User from '@/orm/models/User/User';

export default {
  name: 'AccountMessages',
  components: { AppWithLoading, FeatureAlertCard },
  setup() {
    const { quota, fetchIfNull } = useAccount();
    const { isExpired } = useSubscription();
    const showFeatureAlertCard = ref(true);
    const isExpiredValue = computed(() => (typeof isExpired === 'object' && isExpired !== null && 'value' in isExpired
      ? isExpired.value
      : isExpired));
    const featureAlertVisible = computed(() => Boolean(isExpiredValue.value && showFeatureAlertCard.value));

    return {
      quota,
      fetchIfNull,
      isExpired,
      showFeatureAlertCard,
      featureAlertVisible,
    };
  },
  computed: {
    showVerifyEmailBar() {
      const user = User.getAuthUser();
      return user && !user.emailVerified;
    },
  },
};
</script>

<style lang="scss" scoped>
.plan-ended-bar {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  width: 100%;
  //padding-left: 7.875rem;
  margin-bottom: 2.5rem;
  &:before {
    content: '';
    height: 4.375rem;
    background: #FFF2F2;
    border: 1px solid #ffe5e5;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 3;
  }
  &__wrap {
    display: flex;
    align-items: center;
    height: 3.625rem;
    padding-bottom: 0.75rem;
    position: relative;
    z-index: 4;
  }
  &__text {
    font-weight: 400;
    line-height: 1.25;
    color: #212121;
  }
  &__icon {
    display: inline-block;
    vertical-align: middle;
    margin-right: 0.875rem;
  }
  &__link {
    width: 12.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem 0;
    line-height: 1.45;
    border: 1px solid #ffe5e5;
    font-size: 0.875rem;
    font-weight: 400;
    color: #0A82D9;
    text-decoration: none;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 4;
  }
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .plan-ended-bar {
    font-size: 0.9375rem;
    margin-bottom: 2rem;
    &:before {
      height: 3.75rem;
    }
    &__wrap {
      height: 3rem;
    }
    &__icon {
      width: 1.75rem;
      margin-right: 0.625rem;
    }
    &__link {
      width: 9.875rem;
      padding: 1.125rem 0;
      line-height: 1.6;
    }
  }
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .plan-ended-bar {
    font-size: 0.875rem;
    margin-bottom: 1.25rem;
    &:before {
      height: 4.375rem;
    }
    &__wrap {
      width: 21rem;
      height: 3.625rem;
    }
    &__icon {
      width: 1.5rem;
      margin-right: 0.75rem;
    }
    &__link {
      width: 8rem;
      padding: 1.5rem 0;
      line-height: 1.45;
    }
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .plan-ended-bar {
    display: block;
    font-size: 0.875rem;
    margin-bottom: 1.25rem;
    position: relative;
    &:before {
      height: auto;
      top: -0.75rem;
      left: -0.75rem;
      right: -0.75rem;
      bottom: 0;
    }
    &__wrap {
      width: 100%;
      height: auto;
      padding-bottom: 0;
    }
    &__icon {
      width: 1.5rem;
      margin-left: 0.5rem;
      margin-right: 1rem;
    }
    &__link {
      width: 100%;
      padding: 0.625rem 0;
      border: none;
      position: relative;
      top: inherit;
      right: inherit;
    }
  }
}


</style>

<i18n locale="ru" lang="yaml">
  planEnded: У вас закончились отклики.
  planEndedText: Вы можете выбрать один из подходящих вам тарифов.
  more: Подробнее
</i18n>

<i18n locale="en" lang="yaml">
  planEnded: You have exceeded the number of interviews in your plan.
  planEndedText: Upgrade your plan and see new applicants right now.
  more: More info
</i18n>
